// import { AsYouType, parsePhoneNumberFromString } from "libphonenumber-js";
import i18n from "../plugins/i18n";
import { LocaleMessages } from "vue-i18n";

export interface FormRules {
  (v: string): string | boolean | LocaleMessages;
}

const emailRules: FormRules[] = [
  (v: any) =>
    !v ||
    /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,6})+$/.test(v) ||
    i18n.t("formRules.emailError.notValid")
];

const taxCodeRules: FormRules[] = [
  (v: any) =>
    !v || v.length === 16 || "Il codice fiscale deve essere di 16 caratteri"
];

const mobileRules: FormRules[] = [
  (v: any) =>
    !v ||
    /\+(9[976]\d|8[987530]\d|6[987]\d|5[90]\d|42\d|3[875]\d|2[98654321]\d|9[8543210]|8[6421]|6[6543210]|5[87654321]|4[987654310]|3[9643210]|2[70]|7|1)\d{1,14}$/.test(
      v
    ) ||
    i18n.t("formRules.phoneNumber")
];

// const mobileRules = [
//   (v: any) => {
//     const asYouType = new AsYouType();
//     if (typeof v === "string") {
//       if (v[0] === "0" && v[1] === "0") {
//         const value = v.replace("00", "+");
//         asYouType.input(value);
//       } else {
//         const value = v;
//         asYouType.input(value);
//       }
//       if (asYouType.parsedInput !== "") {
//         // eslint-disable-next-line no-restricted-globals
//         if (v.length !== 1 && isNaN(v[v.length - 1]))
//           return "Invalid phone number";
//         let phoneNumber;
//         if (asYouType.getNumber()) {
//           const { country } = asYouType.getNumber();
//           const { nationalNumber: number } = asYouType.getNumber();
//           phoneNumber = parsePhoneNumberFromString(`Phone: ${number}`, country);
//         }
//         if (phoneNumber !== undefined) {
//           return phoneNumber.isValid() || "Invalid phone number";
//         }
//         return "Complete the number or add the country code. Ex: +39, 0039";
//       }
//     }
//     return !v || "Invalid phone number";
//   }
// ];

const ibanRules = [
  (v: any) =>
    !v ||
    /^(?:(?:IT|SM)\d{2}[A-Z]\d{22}|CY\d{2}[A-Z]\d{23}|NL\d{2}[A-Z]{4}\d{10}|LV\d{2}[A-Z]{4}\d{13}|(?:BG|BH|GB|IE)\d{2}[A-Z]{4}\d{14}|GI\d{2}[A-Z]{4}\d{15}|RO\d{2}[A-Z]{4}\d{16}|KW\d{2}[A-Z]{4}\d{22}|MT\d{2}[A-Z]{4}\d{23}|NO\d{13}|(?:DK|FI|GL|FO)\d{16}|MK\d{17}|(?:AT|EE|KZ|LU|XK)\d{18}|(?:BA|HR|LI|CH|CR)\d{19}|(?:GE|DE|LT|ME|RS)\d{20}|IL\d{21}|(?:AD|CZ|ES|MD|SA)\d{22}|PT\d{23}|(?:BE|IS)\d{24}|(?:FR|MR|MC)\d{25}|(?:AL|DO|LB|PL)\d{26}|(?:AZ|HU)\d{27}|(?:GR|MU)\d{28})$/i.test(
      v
    ) ||
    "Invalid IBAN"
];

const formRules = {
  mandatorySelectCharity: [
    (v: any) => {
      if (v === 0) return true;
      return !!v || "Inserire un valore inferiore o uguale al costo";
    }
    // v => !!v || 'Campo obbligatorio!',
    // v => (v && v !== '') || 'Campo obbligatorio!'
  ],
  mandatorySelect: [
    (v: any) => !!v || "Campo obbligatorio!"
    // v => (v && v !== '') || 'Campo obbligatorio!'
  ],
  mandatoryCheckbox: [(v: any) => !!v || "Campo obbligatorio!"],
  mandatoryField: [
    (v: any) => !!v || i18n.t("formRules.mandatory"),
    (v: any) => (v && v.length > 0) || i18n.t("formRules.mandatory")
  ],
  mandatoryDate: [
    (v: any) => !!v || i18n.t("formRules.date"),
    (v: any) => (v && v.length > 0) || i18n.t("formRules.date")
  ],
  titleRules: [
    (v: any) => !!v || "Inserire il titolo",
    (v: any) => {
      if (typeof v === "string") {
        return v.length <= 50 || "Max 50 caratteri";
      } else if (typeof v === "boolean") {
        return v || "Max 50 caratteri";
      }
      return false;
    }
  ],
  messageRules: [
    (v: any) => !!v || i18n.t("formRules.message.check"),
    (v: any) => {
      if (typeof v === "string") {
        return v.length <= 150 || i18n.t("formRules.message.maxChar");
      } else if (typeof v === "boolean") {
        return v || i18n.t("formRules.message.maxChar");
      }
      return false;
    }
  ],
  charityTitle: [
    (v: any) => !!v || "Inserire il titolo della charity",
    (v: any) => {
      if (typeof v === "string") {
        return v.length <= 50 || "Max 50 caratteri";
      } else if (typeof v === "boolean") {
        return v || "Max 50 caratteri";
      }
      return false;
    }
  ],
  descriptionRules: [
    (v: any) => !!v || "Inserire il messaggio",
    (v: any) => {
      if (typeof v === "string") {
        return v.length <= 140 || "Max 140 caratteri";
      } else if (typeof v === "boolean") {
        return v || "Max 140 caratteri";
      }
      return false;
    }
  ],
  nameRules: [
    (v: any) => !!v || i18n.t("formRules.name.check"),
    (v: any) => {
      if (typeof v === "string") {
        return v.length <= 20 || i18n.t("formRules.name.maxChar");
      } else if (typeof v === "boolean") {
        return v || i18n.t("formRules.name.maxChar");
      }
      return false;
    }
  ],
  surnameRules: [
    (v: any) => !!v || "Inserire il cognome",
    (v: any) => {
      if (typeof v === "string") {
        return v.length <= 20 || "Max 20 caratteri";
      } else if (typeof v === "boolean") {
        return v || "Max 20 caratteri";
      }
      return false;
    }
  ],
  mandatoryCreditCard: [
    (v: any) => !!v || "Campo obbligatorio",
    (v: any) => {
      if (typeof v === "string") {
        return v.length === 16 || "errore";
      } else {
        return "errore";
      }
    }
  ],
  mandatoryNumber: [
    (v: any) => (!!v && v >= 0) || i18n.t("formRules.phoneNumber")
    // (v: any) => (v && v > 0 && v <= 8760) || "Valore massimo: 8760 ore (1 anno)"
  ],
  mandatoryNumberField: [
    (v: any) => !!v || "Campo obbligatorio!",
    (v: any) => (v && v >= 1970) || "L'anno deve essere superiore al 1970!"
  ],
  passwordRules: [
    (v: any) => !!v || i18n.t("formRules.pwdError"),
    (v: any) => {
      if (typeof v === "string") {
        return v.length >= 6 || i18n.t("formRules.pwdLenght");
      } else if (typeof v === "boolean") {
        return v || i18n.t("formRules.pwdLenght");
      }
      return false;
    }
  ],
  confirmPasswordRules: [
    (v: any) => !!v || i18n.t("formRules.confirmPwdError")
  ],
  emailRules,
  taxCodeRules,
  mobileRules,
  mandatoryEmailRules: [
    (v: any) => !!v || i18n.t("formRules.mandatory"),
    ...emailRules
  ],
  mandatoryTaxCodeRules: [
    (v: any) => !!v || "Il codice fiscale è obbligatorio",
    ...taxCodeRules
  ],
  mandatoryCountry: [(v: any) => !!v || "Campo obbligatorio!"],

  mandatoryNumericCode: [(v: any) => !!v || "Campo obbligatorio!"],

  mandatoryMobileRules: [...mobileRules],
  privacyRules: [
    (v: any) =>
      !!v || "Devi accettare le condizioni sulla privacy per continuare!"
  ],
  ibanRules
};

export default formRules;
